import React, { Fragment } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { WarehouseHold } from '../containers/WarehouseHold';
import { WarehouseAvailability } from '../containers/WarehouseAvailability';
import { DirtyWrapper } from 'Components';
import {
  TabEnum,
  PrintSortOptions,
  LoadAvailabilityGroupOptions,
} from 'Common/Constants/Enumeration/WarehouseReports';
import { WarehouseReportEnum } from 'Common/FieldEnum';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';

const WarehouseReportComponent = props => {
  const {
    headerInfo,
    changeTabSelection,
    headerRowButtons,
    onHandleHoldPrintSubmit,
    onHandleAvailabilityPrintSubmit,
    getMainProps,
  } = props;
  return (
    <Fragment>
      <Filter title={'Reports | Warehouse Availability'} newRow={true}>
        <Grid>
          <Grid.Row column={1}>
            <Grid.Column width={12}>
              <label>REPORT TYPE</label>
              <Button.Group basic className="btn-group--active-group">
                {headerRowButtons.map(button => {
                  const { title, value, preferValue } = button;
                  return (
                    <SecurityPreferences
                      scope={preferValue}
                      key={`security${value}`}
                    >
                      {disabled => {
                        return (
                          !disabled && (
                            <Button
                              key={button.title}
                              basic
                              className="white"
                              active={headerInfo === value}
                              onClick={() => changeTabSelection(value)}
                            >
                              {title}
                            </Button>
                          )
                        );
                      }}
                    </SecurityPreferences>
                  );
                })}
              </Button.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Filter>
      <DirtyWrapper>
        {showDirtyConfirm => (
          <Main {...getMainProps()}>
            <SecurityPreferences scope={PrefEnum.WarehouseHold}>
              {disabled => {
                return (
                  !disabled &&
                  headerInfo === TabEnum.Hold && (
                    <WarehouseHold
                      initialValues={{
                        [WarehouseReportEnum.WarehouseKitchen]:
                          GenericEnum.ZeroString,
                        [WarehouseReportEnum.OnHoldTime]:
                          GenericEnum.InitialFilterValue,
                        [WarehouseReportEnum.SortBy]: PrintSortOptions.ItemCode,
                        [WarehouseReportEnum.GroupBy]:
                          LoadAvailabilityGroupOptions.OrderNo,
                      }}
                      onSubmit={onHandleHoldPrintSubmit}
                    />
                  )
                );
              }}
            </SecurityPreferences>
            <SecurityPreferences scope={PrefEnum.WarehouseAvailability}>
              {disabled => {
                return (
                  !disabled &&
                  headerInfo === TabEnum.Availability && (
                    <WarehouseAvailability
                      initialValues={{
                        [WarehouseReportEnum.WarehouseKitchen]:
                          GenericEnum.ZeroString,
                        [WarehouseReportEnum.SortBy]: PrintSortOptions.ItemCode,
                        [WarehouseReportEnum.GroupBy]:
                          LoadAvailabilityGroupOptions.Vendor,
                      }}
                      onSubmit={onHandleAvailabilityPrintSubmit}
                    />
                  )
                );
              }}
            </SecurityPreferences>
          </Main>
        )}
      </DirtyWrapper>
    </Fragment>
  );
};

WarehouseReportComponent.propTypes = {
  changeTabSelection: PropTypes.func,
  fetchWHKITListLoading: PropTypes.bool,
  getHeaderTitle: PropTypes.func,
  getMainProps: PropTypes.func,
  headerInfo: PropTypes.number,
  headerRowButtons: PropTypes.array,
  onHandleAvailabilityPrintSubmit: PropTypes.func,
  onHandleHoldPrintSubmit: PropTypes.func,
};

WarehouseReportComponent.defaultProps = {
  fetchWHKITListLoading: false,
  headerInfo: 0,
  headerRowButtons: [],
  getHeaderTitle: () => {},
  changeTabSelection: () => {},
  getMainProps: () => {},
  onHandleAvailabilityPrintSubmit: () => {},
  onHandleHoldPrintSubmit: () => {},
};

export default WarehouseReportComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/components/WarehouseReports.js